/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {StableIdentifierStoreRequest} from '@cash-web/protos/squareup/cash/cashdotapp/api.pb'
import {StableIdentifierStoreResponse} from '@cash-web/protos/squareup/cash/cashdotapp/api.pb'


export const stableIdentifierStore = (request:StableIdentifierStoreRequest, options?: CashRequestOptions) => post<StableIdentifierStoreRequest, StableIdentifierStoreResponse>("/2.0/cash/web/sid/gen", request, {...options, rejectOnError: true })